import { updateRequestInfoRequest, makeRequestPostData } from '../../signup/modules/signup'

// Import Images

// Constant
import { CHANGE_REQUEST_EDIT_STEP, UPDATE_REQUEST_EDIT_SETTINGS } from '../../../modules/actions'

// Action
const initialState = {
  step: 2,
  payjpToken: true,
  autoSaveNotification: '',
  currentlyUpdating: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_REQUEST_EDIT_SETTINGS:
      return {
        ...state,
        ...action.payload
      }
    case CHANGE_REQUEST_EDIT_STEP:
      return {
        ...state,
        step: action.step
      }
    default:
      return state
  }
}

export const updateRequestEditSettings = (payload) => ({
  type: UPDATE_REQUEST_EDIT_SETTINGS,
  payload
})

export const changeRequestEditStep = (step) => ({
  type: CHANGE_REQUEST_EDIT_STEP,
  step
})

// Thunks
export const submitRequestEdit = () => {
  return (dispatch, getState) => {
    let state = getState()
    let signup = state.signup

    let data = makeRequestPostData(signup)

    dispatch(updateRequestInfoRequest({
      id: signup.requestId,
      data: data,
      successCallback: () => {
        dispatch(updateRequestEditSettings({
          step: 6,
          currentlyUpdating: false,
        }))
      }
    }))
  }
}



// WEBPACK FOOTER //
// ./src/routes/requestEdit/modules/requestEdit.js